export default __webpack_public_path__ + "static/media/Klepetalnik.0672cf0e.png";